import { createPlugin } from "./plugin.mjs";
import { createHeadRecaptcha } from "./script-manager/head.mjs";
export * from "./api.mjs";
const plugin = createPlugin(createHeadRecaptcha);
export { plugin as default, plugin as VueRecaptchaPlugin };
